// Shared skeleton tones for the layout thumbnails. BAR is a neutral placeholder
// row; ACCENT highlights the element a given layout is meant to emphasize.
export const BAR = 'rgba(0,0,0,0.12)';
export const ACCENT = 'magicPurple.200';
